
import React from 'react';
import './App.css';
import Login from './Component/Login';
import {
  createBrowserRouter, HashRouter,
  RouterProvider,
} from "react-router-dom";
import "./index.css";
import SignUp from './Component/SignUp';
import Main from './Component/Main';
import Report from './Component/Report';
import Profile from './Component/Profile';
import Footer from './Component/Footer';
import { Layout } from './layout/Layout';


function App() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <Login />
    },
    {
      path: '/signup',
      element: <SignUp />,
    },
    {
      element: <Layout />,
      children: [
        {
          path: '/report',
          element: <Report />,
        },
        {
          path: '/profile',
          element: <Profile />,
        },
        {
          path: '/footer',
          element: <Footer />,
        }
      ]
    },

  ]);
  return (<>
    <RouterProvider router={router} />
  </>

  );
}

export default App;
